import { render, staticRenderFns } from "./R2024.vue?vue&type=template&id=ed59c4cc&scoped=true"
import script from "./R2024.vue?vue&type=script&lang=js"
export * from "./R2024.vue?vue&type=script&lang=js"
import style0 from "./R2024.vue?vue&type=style&index=0&id=ed59c4cc&prod&lang=less"
import style1 from "./R2024.vue?vue&type=style&index=1&id=ed59c4cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.46.0__css-load_ecc709542230bcceb67dd6366ef941ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed59c4cc",
  null
  
)

export default component.exports